module.exports = __webpack_public_path__ + "img/logo-tax-research.ca137a5f.svg";